var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "asignacionNoSeriado" }, [
    _c(
      "div",
      { staticClass: "layout wrap widgets" },
      [
        _c(
          "v-flex",
          { attrs: { md12: "", layout: "", wrap: "" } },
          [
            _c(
              "v-flex",
              {
                staticStyle: { "padding-right": "0px" },
                attrs: {
                  "offset-md10": "",
                  "offset-sm10": "",
                  sm2: "",
                  md2: ""
                }
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      "padding-top": "6px",
                      "padding-right": "0px"
                    },
                    attrs: { align: "right" }
                  },
                  [
                    _vm.accionCrear.visible && !_vm.showForm
                      ? _c(
                          "v-btn",
                          {
                            staticStyle: { "padding-right": "20px" },
                            attrs: {
                              disabled: _vm.deshabilitar,
                              color: "#ffe800"
                            },
                            on: {
                              click: function($event) {
                                ;(_vm.showForm = true), (_vm.id_editar = "")
                              }
                            }
                          },
                          [
                            _c(
                              "v-icon",
                              {
                                staticStyle: { color: "black" },
                                attrs: { dark: "", left: "" }
                              },
                              [_vm._v("add_circle_outline")]
                            ),
                            _c("span", { staticStyle: { color: "black" } }, [
                              _vm._v("Crear")
                            ])
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]
            )
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showForm,
            expression: "showForm"
          }
        ],
        staticClass: "flex sm10 md10"
      },
      [
        !_vm.loading
          ? _c(
              "FormFieldsContainer",
              [
                _c(
                  "v-flex",
                  { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
                      [
                        _c(
                          "v-flex",
                          { attrs: { sm4: "", md4: "" } },
                          [
                            _c("v-autocomplete", {
                              attrs: {
                                label: _vm.formFields.equipo.label,
                                items: _vm.listaEquipos,
                                "item-text": "nombre",
                                "item-value": "id"
                              },
                              model: {
                                value: _vm.formFields.equipo.value,
                                callback: function($$v) {
                                  _vm.$set(_vm.formFields.equipo, "value", $$v)
                                },
                                expression: "formFields.equipo.value"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "v-flex",
                          { attrs: { sm3: "", md3: "" } },
                          [
                            _c("v-text-field", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "numeric",
                                  expression: "'numeric'"
                                }
                              ],
                              attrs: {
                                label: _vm.formFields.cantidad.label,
                                "error-messages": _vm.errors.collect("ano"),
                                "data-vv-name": "ano",
                                type: "text"
                              },
                              model: {
                                value: _vm.formFields.cantidad.value,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formFields.cantidad,
                                    "value",
                                    $$v
                                  )
                                },
                                expression: "formFields.cantidad.value"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "v-flex",
                          { attrs: { sm3: "", md3: "" } },
                          [
                            _c("v-text-field", {
                              attrs: {
                                label: _vm.formFields.descripcion.label
                              },
                              model: {
                                value: _vm.formFields.descripcion.value,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formFields.descripcion,
                                    "value",
                                    $$v
                                  )
                                },
                                expression: "formFields.descripcion.value"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "v-flex",
                          { attrs: { sm3: "", md3: "" } },
                          [
                            _c("v-text-field", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: false,
                                  expression: "false"
                                }
                              ],
                              attrs: { label: "id" },
                              model: {
                                value: _vm.id_editar,
                                callback: function($$v) {
                                  _vm.id_editar = $$v
                                },
                                expression: "id_editar"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("v-flex", { attrs: { sm12: "", md12: "" } }, [
                  _c("div", { staticClass: "text-sm-center layout" }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "padding-top": "6px",
                          "padding-right": "0px"
                        },
                        attrs: { align: "right" }
                      },
                      [
                        _c(
                          "v-btn",
                          {
                            staticStyle: {
                              "padding-right": "20px",
                              "background-color": "#ff6c00!important",
                              width: "135px"
                            },
                            on: { click: _vm.handleGuardarClick }
                          },
                          [
                            _c(
                              "v-icon",
                              {
                                staticStyle: { color: "white" },
                                attrs: { dark: "", left: "" }
                              },
                              [_vm._v("save")]
                            ),
                            _c("span", { staticStyle: { color: "white" } }, [
                              _vm._v("Guardar")
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "padding-top": "6px",
                          "padding-right": "0px"
                        },
                        attrs: { align: "right" }
                      },
                      [
                        _c(
                          "v-btn",
                          {
                            staticStyle: {
                              "padding-right": "20px",
                              color: "#27488e!important",
                              width: "135px"
                            },
                            on: { click: _vm.handleVolverClick }
                          },
                          [
                            _c(
                              "v-icon",
                              {
                                staticStyle: { color: "black" },
                                attrs: { dark: "", left: "" }
                              },
                              [_vm._v("undo")]
                            ),
                            _c("span", { staticStyle: { color: "black" } }, [
                              _vm._v("Volver")
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ]),
                _c("div", {
                  staticClass: "clearfix",
                  staticStyle: { width: "100%" }
                })
              ],
              1
            )
          : _vm._e()
      ],
      1
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.showForm,
            expression: "!showForm"
          }
        ],
        staticClass: "gridcard rounded-card"
      },
      [
        _c(
          "v-flex",
          {
            attrs: {
              xs12: "",
              "offset-md10": "",
              "offset-sm10": "",
              sm2: "",
              md2: "",
              hide: ""
            }
          },
          [
            _c("v-text-field", {
              staticStyle: { "margin-right": "5px" },
              attrs: { label: "Buscar..." },
              on: { input: _vm.searchData },
              model: {
                value: _vm.filtrobusquedagrilla,
                callback: function($$v) {
                  _vm.filtrobusquedagrilla = $$v
                },
                expression: "filtrobusquedagrilla"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "NoSeriados",
            class: { ocultar_acciones: _vm.deshabilitar }
          },
          [
            _c("MantenedorGridSinCodigo", {
              attrs: {
                "grid-options": _vm.gridOptions,
                "funcionalidad-id": _vm.funcionalidad
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }